import {Link} from "react-router-dom";

import {Button} from "@/components/ui/button";

type ClaimPendingStepProps = {
  message: string;
  email: string;
};

export default function ClaimPendingStep({message, email}: ClaimPendingStepProps) {
  return (
    <div className="flex flex-col gap-4 text-center">
      <p className="text-foreground">{message}</p>
      <p className="text-sm text-muted-foreground">
        We sent a verification link to <span className="font-medium text-foreground">{email}</span>
        . Open it to activate your account.
      </p>
      <Button render={<Link to="/login" />} variant="outline" className="w-full">
        Already verified? Sign in
      </Button>
    </div>
  );
}
